import React from 'react'
import BannerItem from '../../components/banner/BannerItem';
import Footer from '../../components/footer/Footer';
import Header from '../../components/header/Header'
import styles from './Main.module.scss';

const createBannerItemOneCard = () => {
  return (
    <BannerItem
      orientation={'landscape'}
      imgUrl={'/images/games/AIOneCard.png'}
      title={'AI 원카드'}
      detail={'카드'}
      platforms={
        {
          'android' : 'https://play.google.com/store/apps/details?id=com.Mujaedal.AIOneCard',
          'iOS' : 'https://apps.apple.com/us/app/ai-%EC%9B%90%EC%B9%B4%EB%93%9C/id6456793607'
        }
      }
    />)
}

const createBannerItemKiLotto = () => {
  return (
    <BannerItem
      orientation={'landscape'}
      imgUrl={'/images/games/KiLotto.png'}
      title={'Ki 로또'}
      detail={'도구'}
      platforms={
        {
          'android' : 'https://play.google.com/store/apps/details?id=com.Mujaedal.KiLotto'
        }
      }
    />)
}

const createBannerItemBSB = () => {
  return(              
  <BannerItem
    orientation={'landscape'}
    imgUrl={'/images/games/BSB.png'}
    title={'Blockman Survival Battle'}
    detail={'아케이드'}
    platforms={
      {
        'android' : 'https://play.google.com/store/apps/details?id=com.mujaedal.blockmansurvivalbattle'
      }
    }
  />)
}

const createBannerItemEmpty = () => {
  return(              
    <BannerItem
    orientation={'landscape'}
    isLocked={true}
    title={'Coming soon'}
    detail={''}
    platforms={''}
  />
  ) 
}


const Main = () => {
  return (
    <div>
      <Header />

      <div className={styles.wrapper_body}>
        <div id={styles.wrapper_top}>
          <img src={`${process.env.PUBLIC_URL}/images/main.png`} alt='img' />
          <div className={styles.overlay}>
            <div className={styles.title}>
              <p>무한 재미로 가득한 세상을 만드는</p>
              <span style={{ fontSize: "50px" }}>무재달닷컴</span><span>에 오신 것을 환영합니다!</span>
            </div>
          </div>
        </div>

        <div id={styles.wrapper_content}>

          <div className={styles.game_list}>
            <p className={styles.title}>새게임</p>
            <div className={styles.list_view}>
            {createBannerItemOneCard()}
            {createBannerItemEmpty()}
            </div>
          </div>

          <div className={styles.game_list}>
            <p className={styles.title}>인기게임</p>
            <div className={styles.list_view}>
            {createBannerItemOneCard()}
            {createBannerItemBSB()}
            {createBannerItemEmpty()}
            {createBannerItemEmpty()}
            </div>
          </div>

          <div className={styles.game_list}>
            <p className={styles.title}>전체게임</p>
            <div className={styles.nav}>
              <div className={styles.nav_item}>전체#</div>
              <div className={styles.nav_item_disabled}>카드#</div>
              <div className={styles.nav_item_disabled}>아케이드#</div>
              <div className={styles.nav_item_disabled}>기타#</div>
            </div>

            <div className={styles.list_view}>
              {createBannerItemOneCard()}
              {createBannerItemBSB()}
              {createBannerItemKiLotto()}
              {createBannerItemEmpty()}
            </div>
          </div>

        </div>

      </div>

      <Footer />
    </div>
  )
}

export default Main